import { useEffect, useState } from 'react'
import { useRouteError } from 'react-router-dom'

import { ErrorFallback } from '@/shared/components/ErrorFallback'
import { RouteSkeleton } from '@/shared/components/RouteSkeleton'
import { reportError } from '@/shared/lib/errorReporting'
import { isStaleChunkError, reloadOnceForStaleChunk } from '@/shared/lib/staleChunk'

/**
 * `errorElement` de la ruta raíz. Sin él, React Router pinta su pantalla de
 * desarrollo ("Unexpected Application Error… Hey developer 👋") ante cualquier fallo
 * de render o de carga de una ruta — por ejemplo, un chunk que ya no existe tras un
 * despliegue. Código viejo → recarga una vez; cualquier otro error → se reporta y se
 * enseña la pantalla amable compartida.
 */
export function RouteErrorPage() {
  const error = useRouteError()
  const stale = isStaleChunkError(error)
  // Código viejo: mientras recarga, esqueleto. Solo si NO se pudo recargar (ya se
  // recargó hace nada) se cae a la pantalla de error.
  const [reloadFailed, setReloadFailed] = useState(false)

  useEffect(() => {
    if (stale && reloadOnceForStaleChunk()) return
    if (stale) setReloadFailed(true)
    const err = error instanceof Error ? error : new Error(String(error))
    reportError(err, { boundary: 'route' })
  }, [error, stale])

  return stale && !reloadFailed ? <RouteSkeleton /> : <ErrorFallback />
}
